import styled from '@themes/theme'

export const RewardCompleteWrap = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0 21px;
  background: ${props => props.theme.color.themeTxt};
  .reward-img {
    width: auto;
    height: 48px;
    margin-bottom: 7px;
  }
  .reward-value {
    margin-bottom: 14px;
    font-size: ${props=>props.theme.font.title};
    color: ${props=>props.theme.color.modalTxt};
  }
  .reward-complete-txt {
    font-weight: ${props=>props.theme.fontW.medium};
    color: ${props=>props.theme.color.modalgray};
  }
`
